<template>
  <div class="body flex flex-col justify-center items-center relative  h-full md:px-4 py-2  bg-[#1B1A1D]">
    <div class="h-full w-full">
      <header class="flex h-[10%] p-2 justify-between items-center w-full relative md:border-b-2 ">
        <div class="left flex  justify-center md:gap-4 gap-1 items-center text-white">
          <div class="ico border-r-2 w-max  border-r-[#2b2d2e] md:px-4 px-1">
            <img src="/icons/live_video_on.svg" class="w-8 bg-[#FF9900] rounded-md p-1 h-8" alt="">
          </div>
          <h1 class="hidden md:block">{{ $t('salonnumero') }}: ({{ enchere.id }})</h1>
          <div class="date bg-[#2b2d2e] px-2 rounded-full py-1  text-sm">
            {{ Math.floor(time/3600)<10 ? '0'+Math.floor(time/3600) : Math.floor(time/3600) }}:{{ minuteTime }}:{{ secondTime }}
          </div>
          <div v-if="maxAmount > 0">
            <div class="flex space-x-1">
              <div v-if="messages.length > 0 && messages.filter(item => item.user.type != 2).length > 0" class="h-auto flex items-center">
                <p class="text-center">{{ messages.filter(item => item.message == maxAmount.toString())[0]?.user.name }} {{ $t('aencheriunmontantde') }} {{ transformAmount(maxAmount) }}</p>
              </div>
              <div class="h-auto flex items-center">
                <svg class="h-6 fill-white" version="1.0" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 433.000000 577.000000"
                  preserveAspectRatio="xMidYMid meet">

                      <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                      stroke="none">
                      <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                      36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                      -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                      496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                      -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                      91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                      -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                      156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                      -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                      -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                      83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                      -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                      195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                      114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                      172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                      -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                      -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                      124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                      33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                      m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                      c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                      -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                      -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                      m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                      -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                      0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                      -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                      -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                      44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                      -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                      </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class=" rounded-md h-[90%] w-full overflow-hidden relative">
        <div class="body md:p-2 md:pb- gap-1 md:gap-0  md:h-full overflow-hidden flex flex-col xl:flex-row w-full bg-[#1B1A1D] h-full relative">
          <div class="left rounded-md h-1/2 xl:h-full gap-3 w-full xl:w-[70%] relative overflow-hidden">
            <div class="xl:w-[95%] w-full h-full relative flex flex-col  mx-auto group">
              <div v-if="enchere.status=='termine'" class="w-full h-full absolute bg-black bg-opacity-80 rounded-md z-40 flex items-center justify-center">
                <div>
                  <div class="space-x-1">
                    <div class="w-auto flex justify-center">
                      <h1 class="text-white text-xl lg:text-4xl text-center">{{ $t('ventesencheretermine') }}</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="hidAdjugeVendu" class="w-full h-full absolute bg-black bg-opacity-80 rounded-md z-40 flex items-center justify-center">
                <div>
                  <div class="space-x-1">
                    <div class="w-auto flex justify-center">
                      <h1 class="text-white text-xl lg:text-4xl text-center">{{ $t('adjugervendu') }} {{ acheteur.venduA.name }}</h1>
                    </div>
                    <div class="w-auto flex justify-center space-x-1">
                      <h1 class="text-white text-xl lg:text-4xl text-center">{{ $t('pourlemontantde') }} {{ transformAmount(acheteur.montant) }}</h1>
                      <svg class="h-7 lg:h-10 fill-white" version="1.0" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 433.000000 577.000000"
                        preserveAspectRatio="xMidYMid meet">
      
                            <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                            stroke="none">
                            <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                            36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                            -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                            496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                            -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                            91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                            -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                            156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                            -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                            -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                            83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                            -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                            195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                            114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                            172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                            -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                            -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                            124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                            33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                            m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                            c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                            -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                            -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                            m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                            -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                            0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                            -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                            -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                            44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                            -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                            </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loadMessage" class="absolute w-full h-full z-40 bg-black bg-opacity-80 flex justify-center rounded-md">
                <div  class=" mx-auto relative flex items-center">
                  <div id="page">
                    <div id="container">
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <img class="h-20 mx-auto" src="/logo/mel_logo_noir.png" alt="" srcset="">
                    </div>
                  </div>
                </div>
              </div>
              <div  class=" flex-shrink-0 w-full   gap-2 flex absolute right-0 left-0 mx-auto  ">
                <swiper
                  v-if="enchere.users_actif" 
                  :class="hidParticipant ? 'translate-0' : '-translate-y-full'"
                  :slidesPerView="'auto'"
                  :modules="modules"
                  class="mySwiperParticipant transform transition-all duration-1000 bg-[#1B1A1D] bg-opacity-50 z-10" 
                >
                <swiper-slide v-for="userActif in enchere.users_actif.filter(item => item.id != user.id)" :key="userActif.id" class="swiper-slide-participant cursor-pointer px-1">
                  <div class="border-2 w-full h-full border-blue rounded-md relative bg-[#1B1A1D] ">
                    <img v-if="userActif.avatar" class="w-full h-full object-cover" :src="userActif.avatar" alt="" srcset="">
                    <img v-if="userActif.avatar == '' || userActif.avatar == null" class="w-full h-full mx-auto object-contain object-center  " src="/logo/mel_logo_noir.png" alt="" srcset="">
                    <div class="footer absolute bottom-2 px-1 w-full flex  items-center justify-between">
                      <div class="icons w-6 h-6 bg-black/50 rounded-full p-1 flex justify-center items-center">
                        <div class="w-3 h-3 bg-green-500 rounded-full"></div>
                      </div>
                      <h1 class="rounded-full px-2 py-1 bg-black bg-opacity-50 first-letter:uppercase text-center text-white font-semibold text-[0.6rem]">
                        {{ userActif.name }}
                      </h1>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              </div>
              <div class="mainVideo h-full w-full rounded-md">
                <h1 class="absolute left-1 top-1 bg-black bg-opacity-50 rounded-md text-white py-1 first-letter:uppercase text-center transform xl:-translate-y-[125%] group-hover:translate-y-0 transition duration-1000">
                  MEL {{ $t('cameroun') }}
                </h1>
                <video id="video" muted data-object-fit="cover" :src="articleSelect.video" class=" w-full h-full object-cover rounded-md aspect-video" autoplay playsinline loop data-wf-ignore="true">
                </video>
              </div>
              <div class="footer w-full absolute bottom-2 flex justify-between items-center px-1 transform xl:translate-y-[125%] group-hover:translate-y-0 transition duration-1000">
                <div @click="copyLink"
                  class="left flex rounded-md cursor-pointer gap-1 justify-center items-center text-sm md:text-base w-10 md:w-auto  px-1 md:px-3 py-2 bg-[#2b2d2e] text-white ">
                  <span class="border-r border-r-fond-sms pr-2 text-sm hidden md:inline">{{ $t('copierlelien') }}</span> 
                  <img src="/icons/restore_down.svg" class="w-6" alt="">
                </div>
                <div class="center btns flex gap-4">
                  <div @click="muteVideo" :class="mute ? 'bg-[#D95140]':'bg-[#2b2d2e]'" class="btn cursor-pointer h-10 w-10  rounded-md flex items-center justify-center transition-all duration-500">
                    <img :src="mute ? '/icons/no_audio.svg':'/icons/speaker.svg'" class="w-6" alt="">
                  </div>
                  <div @click="pauseVideo" class="btn h-10 w-10 bg-[#2b2d2e] cursor-pointer rounded-md flex items-center justify-center">
                    <div class="ico w-6 h-6 flex justify-center items-center border-2 rounded-md">
                      <img :src="pause ? '/icons/play.svg':'/icons/pause.svg'" class="w-3 transition duration-1000" alt="">
                    </div>
                  </div>
                  <div @click="hidParticipant =! hidParticipant" class="btn cursor-pointer h-10 w-10 bg-[#2b2d2e] rounded-md flex items-center justify-center">
                    <div :class="hidParticipant ? 'transform rotate-0':'transform rotate-90 origin-center'" class="ico flex gap-1 justify-center items-center transition duration-1000">
                      <div class="rond h-1 w-1 border rounded-full" v-for="( index) in 3" :key="index">

                      </div>
                    </div>
                  </div>
                </div>
                <div @click="leaveMeet" class="right cursor-pointer bg-[#D95140] text-sm md:text-base text-white px-1 md:px-3 py-2 rounded-md">{{ $t('quitterlarencontre') }}</div>
              </div>
            </div>
          </div>
          <div class="right  w-full h-1/2  flex xl:w-[30%] xl:h-auto  relative flex-col gap-3 bg-[#3D4042] rounded-md px-3 py-2 ">
            <div class="w-full h-14 relative rounded-md overflow-hidden">
                <div class="w-full h-full bg-[#1b1a1d] flex">
                    <div :class="selectVolet=='group' ? 'ml-0':'ml-[50%]'" class="w-1/2 rounded-md h-full bg-[#FF9900] transition-all duration-1000"></div>
                </div>
                <ul class="header w-full flex h-full absolute top-0 text-white rounded-md p-1">
                    <li @click="changeVolet" class="w-1/2 cursor-pointer rounded-md h-full flex justify-center items-center">{{ $t('group') }}</li>
                    <li @click="changeVolet" class="w-1/2 cursor-pointer rounded-md h-full flex justify-center items-center">{{ $t('infosarticle') }}</li>
                </ul>
            </div>
            <div v-if="selectVolet=='infos'" class="flex h-full px-1 relative bar-off scrollbar-hide overflow-y-auto gap-2 flex-col text-white contains">
              <div v-if="articleSelect.image" class="w-full h-full overflow-y-auto">
                <div class="w-full relative">
                    <swiper 
                      :slidesPerView="'auto'"
                      :modules="modules"
                      class="mySwiper bg-black" 
                      :loop="true"
                      :autoplay="true"
                    >
                      <swiper-slide v-for="(image) in JSON.parse(articleSelect.image)" :key="image.id" class="w-full h-full">
                        <img class="w-full h-full object-cover object-center" :src="image"  srcset="">
                      </swiper-slide>
                    </swiper>
                  </div>
                  <div class="text-gray-500 underline">
                      <p>Prix de depart</p>
                  </div>
                  <div class="mt-3">
                      <div class="flex space-x-1">
                        <div class="h-auto flex items-center">
                          <p class=" font-serif text-xl text-white">{{ articleSelect.prix }}</p>
                        </div>
                        <div class="h-auto flex items-center">
                          <svg class="h-6 fill-white" version="1.0" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 433.000000 577.000000"
                            preserveAspectRatio="xMidYMid meet">
    
                                <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                                stroke="none">
                                <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                                36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                                -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                                496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                                -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                                91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                                -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                                156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                                -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                                -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                                83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                                -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                                195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                                114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                                172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                                -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                                -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                                124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                                33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                                m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                                c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                                -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                                -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                                m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                                -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                                0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                                -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                                -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                                44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                                -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                                </g>
                          </svg>
                        </div>
                    </div>
                  </div>
                  <div class="text-gray-500 underline">
                      <p>{{ $t('description') }}</p>
                  </div>
                  <div class="text-[13px] text-justify">
                      <p>{{ articleSelect.description }}</p>
                  </div>
                  <ul class="max-w-md space-y-1 text-gray-500 list-inside dark:text-gray-400 mt-3">
                      <li v-if="articleSelect.couleur" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('couleur') }}: <span class="text-white font-semibold">{{
                            articleSelect.couleur
                          }}</span></p>
                      </li>
                      <li v-if="articleSelect.taille" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('taille') }}: <span class="text-white font-semibold font-serif">{{
                            articleSelect.taille }}</span></p>
                      </li>
                      <li v-if="articleSelect.ville" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('ville') }}: <span class="text-white font-semibold font-serif">{{
                            articleSelect.ville }}</span></p>
                      </li>
                      <li v-if="articleSelect.stockage" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('stockage') }}: <span class="text-white font-semibold font-serif">{{
                            articleSelect.stockage }} Go</span></p>
                      </li>
                      <li v-if="articleSelect.pixel_camera_avant" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('pixelcameraavant') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.pixel_camera_avant }}
                                  mégapixel</span></p>
                      </li>
                      <li v-if="pixel_camera_arriere" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('pixelcameraarriere') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.pixel_camera_arriere
                                  }} mégapixel</span></p>
                      </li>
                      <li v-if="articleSelect.ram" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('ram') }}: <span class="text-white font-semibold font-serif">{{
                              articleSelect.ram
                          }} Go</span></p>
                      </li>
                      <li v-if="articleSelect.empreinte == 'oui'" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('empreinte') }}: <span class="text-white font-semibold font-serif">{{
                              articleSelect.empreinte }}</span></p>
                      </li>
                      <li v-if="articleSelect.empreinte == 'non'" class="flex items-center">
                        <svg class="w-3.5 h-3.5 mr-2 text-gray-500 dark:text-gray-400 flex-shrink-0"
                            aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path
                                d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                        </svg>
                        <p>{{ $t('empreinte') }}: <span class="text-white font-semibold font-serif">{{
                          articleSelect.empreinte }}</span></p>
                    </li>
                      <li v-if="articleSelect.cpu" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('cpu') }}: <span class="text-white font-semibold font-serif">{{
                              articleSelect.cpu
                          }} Ghz</span></p>
                      </li>
                      <li v-if="articleSelect.systeme_exploitation" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('systemedexploitation') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.systeme_exploitation
                                  }}</span></p>
                      </li>
                      <li v-if="articleSelect.carte_graphique_dedie" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('cartegraphiquededie') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.carte_graphique_dedie
                                  }} Go</span></p>
                      </li>
                      <li v-if="articleSelect.etat" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('etat') }}: <span class="text-white font-semibold font-serif">{{
                              articleSelect.etat }}</span></p>
                      </li>
                      <li v-if="articleSelect.taille_pouce" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('tailleenpouce') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.taille_pouce }} Pouces</span></p>
                      </li>
                      <li v-if="articleSelect.quantite_litre" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('quantiteenlitre') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.quantite_litre }} litre</span></p>
                      </li>
                      <li v-if="articleSelect.quartier" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('quartier') }}: <span class="text-white font-semibold font-serif">{{
                              articleSelect.quartier }}</span></p>
                      </li>
                      <li v-if="articleSelect.superficie" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('superficie') }}: <span class="text-white font-semibold font-serif">{{
                              articleSelect.superficie }} Mètre carré</span></p>
                      </li>
                      <li v-if="articleSelect.nombre_piece" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('nombredepiece') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.nombre_piece }} pièce(s)</span></p>
                      </li>
                      <li v-if="articleSelect.nombre_chambre" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('nombredechambre') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.nombre_chambre }} chambre(s)</span></p>
                      </li>
                      <li v-if="articleSelect.nombre_salon" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('nombredesalon') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.nombre_salon }} Salon(s)</span></p>
                      </li>
                      <li v-if="articleSelect.nombre_douche" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('nombrededouche') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.nombre_douche }} Douche(s)</span></p>
                      </li>
                      <li v-if="articleSelect.nombre_cuisine" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('nombredecuisine') }}: <span
                                  class="text-white font-semibold font-serif">{{
                                      articleSelect.nombre_cuisine }} Cuisine(s)</span></p>
                      </li>
                      <li v-if="articleSelect.numero_direct" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('numerodirect') }}: <span
                                  class="text-white font-semibold font-serif">+237
                                  {{ articleSelect.numero_direct }}</span></p>
                      </li>
                      <li v-if="articleSelect.numero_whatsapp" class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('numerowhatsapp') }}: <span
                                  class="text-white font-semibold font-serif">+237 {{
                                      articleSelect.numero_whatsapp
                                  }}</span></p>
                      </li>
                      <li class="flex items-center">
                          <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                              aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                              viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          <p>{{ $t('quantitedisponible') }}: <span
                                  class="text-white font-semibold font-serif">2</span></p>
                      </li>
                  </ul>
              </div>
            </div>
            <div v-if="selectVolet=='group' && loadMessage==true" class=" h-full  px-1 relative bar-off scrollbar-hide overflow-hidden text-white">
              <div  class="flex flex-col w-full h-full  gap-2 contains">
                <div v-for="i in 20" :key="i.id" :class=" i % 2 == 0  ? 'justify-end':'justify-start'" class="w-full  rounded-lg flex">
                  <div :class="i % 2 == 0 ? 'bg-[#2B2D2E] rounded-bl-lg':'bg-[#1B1A1D] rounded-br-lg'" class="min-w-[40%] max-w-[60%] h-14 animate-pulse py-1 px-2 rounded-tl-lg rounded-tr-lg">
                    
                  </div>
                </div>
              </div>
            </div>
            <div id="zone-message" @scroll="loadInfinite" v-if="selectVolet=='group' && loadMessage==false" class=" h-full px-1 relative bar-off scrollbar-hide overflow-y-auto text-white">
              <div v-if="messages.length == 0" class="w-full h-full flex items-center justify-center">
                <p>Aucun message !</p>
              </div>
              <div v-if="messages.length > 0" class="flex flex-col w-full gap-2 contains">
                <div v-if="fin == false && scrollExec" class="w-full flex items-center py-2">
                  <div class="chaotic-orbit mx-auto"></div>
                </div>
                <div class="w-full flex mt-1 text-gray-500 text-xs" v-if="fin" >
                  <p class="mx-auto" v-if="langue == 'fr'">Plus aucun messages !</p>
                  <p class="mx-auto" v-if="langue == 'en'">No more messages !</p>
                </div>
                <div v-for="(message, index) in messages" :key="message.id" :class="message.user_id == user.id ? 'justify-end':'justify-start'" class="w-full  rounded-lg flex">
                  <div :class="message.user_id == user.id ? 'bg-[#2B2D2E] rounded-bl-lg':'bg-[#1B1A1D] rounded-br-lg'" class="min-w-[40%] max-w-[80%] py-1 px-2 rounded-tl-lg rounded-tr-lg">
                    <div class=" flex justify-between items-center h-8 space-x-2">
                      <div class="flex items-center space-x-2">
                        <div class="h-5 w-5 rounded-full bg-white overflow-hidden">
                          <img v-if="message.user.avatar" class="w-full h-full object-cover" :src="message.user.avatar" alt="" srcset="">
                          <img v-if="message.user.avatar == '' || message.user.avatar == null" class="w-full h-full mx-auto object-cover object-center  " src="/logo/mel_logo_noir.png" alt="" srcset="">
                        </div>
                        <div class="h-auto flex items-center">
                          <p class="font-semibold text-[12px] ">{{ message.user.name }}</p>
                        </div>
                      </div>
                      <p class="text-[8px] items-end flrex justify-end">{{ heureMinute(message.created_at) }}</p>
                    </div>
                    <div class="p-0">
                      <div class="flex space-x-1">
                          <div class="h-auto flex items-center">
                              <p class="font-serif text-[11px]" :id="index">{{ message.user.type != 2 ? transformAmount(parseInt(message.message)) : convertTextInGras(message.message, index) }}</p>
                          </div>
                          <div v-if="message.user.type != 2" class="h-auto flex items-center">
                            <svg class="h-4 fill-white" version="1.0" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 433.000000 577.000000"
                              preserveAspectRatio="xMidYMid meet">
      
                                  <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                                  stroke="none">
                                  <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                                  36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                                  -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                                  496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                                  -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                                  91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                                  -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                                  156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                                  -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                                  -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                                  83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                                  -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                                  195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                                  114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                                  172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                                  -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                                  -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                                  124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                                  33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                                  m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                                  c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                                  -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                                  -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                                  m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                                  -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                                  0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                                  -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                                  -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                                  44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                                  -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                                  </g>
                            </svg>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="articleSelect.status == 'vendu'" class="group h-16 w-full flex items-center justify-center">
              <p class="text-white">{{ $t('artciclevendu') }}</p>
            </div>
            <div v-if="articleSelect.status && articleSelect.status != 'vendu' && articleSelect.ville != user.ville" class="group h-16 w-full flex items-center justify-center">
              <p class="text-white">{{ $t('articlenonvendudansvotreville') }}</p>
            </div>
            <div v-if="articleSelect.status != 'vendu' && articleSelect.ville == user.ville" class="group h-16 w-full ">
              <form @submit.prevent="sendMessage"
                class="footer animation-all duration-1000 bg-[#1B1A1D] w-full py-2 px-1 relative h-full  rounded-md  flex items-center justify-center    border border-transparent group-focus-within:border-[#ff9900] overflow-hidden">
                <input @keyup="verifyNumericWrite" id="idMessage" v-model="form.message" required min="1" type="number" :placeholder="$t('ecrivezunmontant')" 
                class="w-full h-full placeholder:text-[#444547] placeholder:text-[0.8rem] bg-transparent text-white py-2 px-5 rounded-md outline-none" style="-moz-appearance:textfield"> 
                <button :class="user.status == 'block' ? 'opacity-50':'opacity-100'" :disabled="user.status == 'block'? true:false" class="rounded-md bg-[#ff9900] p-2 cursor-pointer z-10">
                  <svg class="w-7 h-7 fill-white p-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 208 208" version="1.1">
                    <g id="surface1">
                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 196.230469 0 C 195.183594 0.125 194.199219 0.460938 193.277344 0.984375 L 4.1875 103.410156 C 1.445313 104.917969 -0.125 107.933594 0.214844 111.042969 C 0.523438 114.148438 2.675781 116.765625 5.664063 117.6875 L 55.890625 132.707031 C 57.058594 142.003906 62.292969 182.226563 63.277344 190.074219 C 64.261719 197.894531 69.554688 199.246094 74.847656 192.046875 C 78.417969 187.183594 99.46875 157.574219 99.46875 157.574219 L 144.28125 202.386719 C 146.25 204.355469 149.113281 205.125 151.789063 204.417969 C 154.5 203.710938 156.589844 201.617188 157.328125 198.9375 L 204.601563 9.847656 C 205.308594 7.355469 204.695313 4.679688 203.03125 2.707031 C 201.339844 0.738281 198.816406 -0.277344 196.230469 0 Z M 184.90625 23.144531 L 145.265625 181.703125 L 100.699219 137.140625 L 165.453125 47.273438 L 64.753906 119.167969 L 28.066406 108.332031 Z "/>
                    </g>
                  </svg> 
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router"
import { Swiper, SwiperSlide } from 'swiper/vue';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import { Autoplay, FreeMode } from 'swiper';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
       modules: [Autoplay, FreeMode],
    };
  },
  beforeRouteLeave() {
    if(this.enchere.status == 'direct'){
      this.absentEnchere()
    }
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  data(){
    return{
      wallet:'',
      hidParticipant:false,
      mute:false,
      pause:false,
      time:0,
      user:'',
      enchere:'',
      selectVolet:'group',
      articleSelect:{},
      messages:[],
      form:{
        message:''
      },
      scrollExec:false,
      fin:false,
      page:1,
      loadMessage:true,
      initialScroll:0,
      maxAmount:0,
      acheteur:{
        venduA:'',
        montant:0
      },
      hidAdjugeVendu:false, 
      langue:'',
      animationConfetti:'',
      oldValue:''
    }
  },
  watch:{
  },

  created(){
    window.addEventListener("beforeunload", this.handleBeforeUnload) 

    window.emitter.on("enchere-termine", (data) => {
      if(data['enchere'].id == this.enchere.id){
        this.bravoAnimation()
        if(this.music){
          this.music.pause()
        }
        this.music = new Audio(
          "/music/feuartifice.mp3"
        )
        this.music.autoplay = true
        this.music.loop = true
      }
    })
  },
  unmounted(){
    if(this.animationConfetti){
      this.animationConfetti.stop()
      this.music.pause()
    }
    document.documentElement.classList.remove('dark')
    if(document.querySelector('video')){
      document.querySelector('video').ontimeupdate=()=>{}
    }
    window.onbeforeunload = null;

    if(document.getElementById('confetti')){
      document.getElementById('confetti').remove()
    }
  },
  mounted(){
    this.requestAuth == 'NotAuth' ? this.$router.push('/login'):''
    this.user.status == 'block' ? this.$router.push('/'):''
   
    this.langue =localStorage.getItem('langue');
    if(localStorage.getItem('jwtToken') == null || localStorage.getItem('jwtToken') == '' || localStorage.getItem('jwtToken') == false){
      this.$router.push('/login');
    }
    if(this.$store.state.containerNeige){
      document.getElementById('snow').remove()
    }
    var script = document.createElement('script');
    script.src = "https://cdn.jsdelivr.net/npm/tsparticles-preset-confetti@2/tsparticles.preset.confetti.bundle.min.js";
    script.id = "confetti"
    document.head.appendChild(script);

    this.wallet = this.$store.state.wallet
    var route = useRoute()
    this.enchere = route.query
    this.enchere.id = this.$decrypto(this.enchere.id)
    this.user = this.requestAccueil[0]
    this.mute = true
    this.$store.state.preview = ''
    document.documentElement.className = 'dark'

    document.querySelector('video').ontimeupdate=()=>{
      this.time = document.querySelector('video').currentTime
    }

    this.axios.get(this.requestHttp + 'find-enchere/' + this.enchere.id, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
      },
    }).then(({ data }) => {
      this.enchere = data[0]
      this.articleSelect = this.enchere.articles_actif[0]

      this.messages = this.enchere.articles_actif[0].messages.reverse()
      this.loadMessage = false
      if(this.messages && this.messages.filter(item => item.user.type != 2).length > 0){
        this.maxAmount = Math.max(...this.messages.filter(item => item.user.type != 2).map(object => { return parseInt(object.message) }))
      }else{
        this.maxAmount = this.articleSelect.prix
      }

      this.$nextTick(() => {
        if(document.getElementById('zone-message')){
          document.getElementById('zone-message').scrollTop = 99999999999999
        }
      })
      this.page += 1

      if(this.enchere.articles_actif[0].status == 'vendu'){
        this.acheteur.venduA = this.messages.filter(item => item.message == this.maxAmount.toString())[0].user
        this.acheteur.montant = this.maxAmount 
        this.hidAdjugeVendu = true
        this.bravoAnimation()
        if(this.music){
          this.music.pause()
        }
        this.music = new Audio(
          "/music/feuartifice.mp3"
        )
        this.music.autoplay = true
        this.music.loop = true
      }
      
      if(this.enchere.status == 'direct'){
        this.presentEnchere()
      }


      window.Echo.channel('adjuge-vendu.' + this.enchere.id).listen('EventEnchere.EventAdjugeVendu',(e)=>{
        this.acheteur.venduA = e['user']
        this.acheteur.montant = e['montant']
        this.articleSelect.status = 'vendu'
        this.hidAdjugeVendu = true
        this.bravoAnimation()
        if(this.music){
          this.music.pause()
        }
        this.music = new Audio(
          "/music/feuartifice.mp3"
        )
        this.music.autoplay = true
        this.music.loop = true
      })
      window.Echo.channel('next-article.' + this.enchere.id).listen('EventEnchere.NextArticleEvent',(e)=>{
        if(this.animationConfetti && JSON.parse(e['articleSelect']).status !='vendu'){
          this.hidAdjugeVendu = false
          this.music.pause()
          this.animationConfetti.stop()
        }
        this.articleSelect = JSON.parse(e['articleSelect'])
        this.allMessages()
      })
      window.Echo.channel('send-message.' + this.enchere.id).listen('EventEnchere.SendMessageEvent',(e)=>{
        if(e['user'].id != this.user.id){
          this.messages.push(e['message'])
          this.messages[this.messages.length - 1].user = e['user']
          this.maxAmount = Math.max(...this.messages.filter(item => item.user.type != 2).map(object => { return parseInt(object.message) }))
          if(e['user'].type != 2){
            if(this.music){
              this.music.pause()
            }
            this.music = new Audio(
              "/music/sonnericaisseenregistreuse.mp3"
            )
            this.music.autoplay = true
          }
          this.autoScroll()
        }
      }) 

      window.Echo.channel('absent-enchere.' + this.enchere.id).listen('EventEnchere.EventAbsentEnchere',(e)=>{
        if(this.enchere.users_actif.length > 0){
          this.enchere.users_actif.filter((item, index) => item.id == e['user'].id ? this.enchere.users_actif.splice(index, 1):'')
        }
      })

      window.Echo.channel('enchere-present.' + this.enchere.id).listen('EventEnchere.EventPresentEnchere',(e)=>{ 
        if(this.enchere.users_actif.filter(item => item.id == e['user'].id).length == 0){
          this.enchere.users_actif.unshift(e['user']) 
        }
      })
    })
    .catch((error) => {
      console.log(error) 
    });
    
  },
  methods:{
    handleBeforeUnload(e){
      var confirmationMessage = "o/";
      (e || window.event).returnValue = confirmationMessage;
      this.absentEnchere()
      return confirmationMessage;
    },
    muteVideo(){
      this.mute =! this.mute
      document.querySelector('video').muted =! document.querySelector('video').muted
    },
    pauseVideo(){
      this.pause ? document.querySelector('video').play():document.querySelector('video').pause()
      this.pause =! this.pause
    },
    leaveMeet(){
      this.$router.push('encheres')
    },
    allMessages(){
      this.page=1
      this.fin = false
      this.scrollExec = false
      this.loadMessage = true
      this.axios.get(this.requestHttp + 'all-message-article-enchere/' + this.articleSelect.id,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({data}) => {
        this.messages = data[0].data.reverse()
        this.page += 1
        this.loadMessage = false
        if(this.messages.filter(item => item.user.type != 2).length > 0){
          this.maxAmount = Math.max(...this.messages.filter(item => item.user.type != 2).map(object => { return parseInt(object.message) }))
        }else{
          this.maxAmount = this.articleSelect.prix
        }

        this.$nextTick(() => {
          if(document.getElementById('zone-message')){
            document.getElementById('zone-message').scrollTop = 99999999999999
          }
        })
      })
      .catch((error) => {
        console.log(error)
      });
    },
    sendMessage(){
      if(this.form.message <= this.wallet.montant){
        if(this.form.message <= this.maxAmount){
          window.emitter.emit("alertError", ['solde insuffisant', this.$i18n.messages[`${localStorage.getItem('langue')}`].encherissezunmontantsuperieur])
        }else{
          this.axios.post(this.requestHttp + 'save-message',{message: this.form.message, article_id: this.articleSelect.id, enchere: JSON.stringify(this.enchere)},
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
            },
          }).then(({data}) => {
            if(data.verify == true){
              window.emitter.emit("alertError", ['solde insuffisant', this.$i18n.messages[`${localStorage.getItem('langue')}`].montantdejapropose])
              const index = this.messages.findIndex(item => 
              item.article_id == data.messageDelete.article_id && 
              item.user.id == data.messageDelete.user_id && 
              item.message == data.messageDelete.message
              );
              if (index !== -1) {
                this.messages.splice(index, 1);
              }
            }
          })
          .catch((error) => {
            console.log(error)
          });
          this.messages.push({
            user_id: this.user.id,
            article_id: this.articleSelect.id,
            user: this.user,
            message: this.form.message,
            created_at: new Date()
          })
          this.form.message = ''
          this.maxAmount = Math.max(...this.messages.filter(item => item.user.type != 2).map(object => { return parseInt(object.message) }))

          this.autoScroll()
        }
      }else{
        window.emitter.emit("alertError", ['solde insuffisant', this.$i18n.messages[`${localStorage.getItem('langue')}`].veuillezrechargerwallet])
      }
    },
    convertTextInGras(titre, index) {
      // Vérifier si titre est un entier
      if (Number.isInteger(titre)) {
        return titre;
      }

      // Remplacement des balises <...> par une version en gras
      const regex = /<([^>]+)>/g;
      titre = titre.replace(regex, (match, contenu) => {
        return `<span class="font-bold text-xs text-[#FF9900]">${contenu}</span>`;
      });

      // Remplacer les occurrences "/n" par des sauts de ligne HTML <br>
      titre = titre.replace(/\/n/g, '<br><div class="mt-[0.15rem] md:mt-[0.1rem]"></div>');
      // Mise à jour du contenu dans le DOM
      this.$nextTick(() => {
        document.getElementById(`${index}`).innerHTML = titre;
      });

      return titre.trim();
    },
    autoScroll(){
      if(document.getElementById('zone-message')){
        var elementDom = document.getElementById('zone-message')
        const max=elementDom.scrollHeight
        const base=elementDom.clientHeight
        const scrollY=elementDom.scrollTop 
        if(max == Math.floor(base + scrollY)){
          this.$nextTick(() => {
            elementDom.scrollTop = 99999999999999  
          })  
        }
      }
    },
    infiniteHandler(){
      this.axios.get(this.requestHttp + 'all-message-article-enchere/' + this.articleSelect.id +'?page=' + this.page,
            {
                headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                },
      }).then(({data}) => {
        if(data[0].data.length > 0){
          this.messages.unshift(...data[0].data.reverse())
          this.page += 1
          this.scrollExec = false
          if(document.getElementById('zone-message').scrollTop == 0){
            this.$nextTick(() => {
              document.getElementById('zone-message').scrollTop = this.initialScroll
            })   
          }
        }else{
          this.fin = true
        }
      })
      .catch((error) => {
        console.log(error)
      });
    },
    loadInfinite(e){
      const max=e.target.scrollHeight //la partie que la bar de scroll doit parcourir + la hauteur de la bar de scroll
      const base=e.target.clientHeight //la hauteur de la bar de scroll
      const scrollY=e.target.scrollTop //la distance parcouru par la bar du scroll
      const delta=max-base
      this.initialScroll = e.target.scrollHeight
      //console.log(max, max * 50/100, delta, 'base:' + base, 'scrollY:' +scrollY);
      this.$store.dispatch('requestRouterLastPosition', {name:'scrollMessageEnchere', scrollPosition:e.target.scrollTop})
      if(scrollY <= delta * 50/100 && this.scrollExec == false){
          this.scrollExec = true
          this.infiniteHandler()
      }
    },
    changeVolet(){
      this.selectVolet == 'group' ? this.selectVolet='infos':this.selectVolet='group'
      this.$nextTick(() => {
        if(document.getElementById('zone-message')){
          document.getElementById('zone-message').scrollTop = this.$store.state.routerLastPosition['scrollMessageEnchere'] 
        }
      }) 
    },
    heureMinute(date){
      var convert= new Date(date)
      var heure = convert.getHours() < 10 ? '0'+convert.getHours():convert.getHours()
      var minute = convert.getMinutes() < 10 ? '0'+convert.getMinutes():convert.getMinutes()
      return heure + ':' + minute
    },
    transformAmount(value){
      var result = ''
      if(value > 0){
        var text = Math.round(value).toString()
        var countElement = ''
        for (let i = 1; i <= text.length; i++) {
          result = text[text.length - i] + result
          countElement += text[text.length - i]
          if(countElement.length < text.length && countElement.length%3 == 0){
            result = (localStorage.getItem('langue') == 'fr' ? ',':'.') + result
          }
        }
      }else{
        result = value
      }
      
      return result
    },
    presentEnchere(){
      this.axios.post(this.requestHttp + 'present-enchere',
            { enchere: JSON.stringify(this.enchere) }, 
            {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
            },
        }).then(() => {

        })
      .catch((error) => {
        console.log(error)
      });
    },
    absentEnchere(){
      this.axios.post(this.requestHttp + 'absent-enchere',
            { enchere: JSON.stringify(this.enchere) }, 
            {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
            },
        }).then(() => {

        })
      .catch((error) => {
        console.log(error)
      });
    },
    copyLink(){
      var input = document.createElement('input');
      var url = window.location.href;
      document.body.appendChild(input)
      input.value = url
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      window.emitter.emit("alertSucces", ['copy link', this.$i18n.messages[`${localStorage.getItem('langue')}`].messagliencopy])
    }, 
    async bravoAnimation(){ 
      this.animationConfetti = await window.tsParticles.load("tsparticles", {
          emitters: [{
              life: {
                duration: 0,
                count: 1,
              },
              position: {
                x: 0,
                y: 30,
              },
              particles: {
                move: {
                  direction: "top-right",
                },
              },
            },
            {
              life: {
                duration: 0,
                count: 1,
              },
              position: {
                x: 100,
                y: 30,
              },
              particles: {
                move: {
                  direction: "top-left",
                },
              },
            },
          ],
          preset: "confetti",
      });
    },
    verifyNumericWrite(){
      if(event.key.length == 1){
        if(event.key.match(/^(?=.*[0-9])/)){
          this.oldValue = this.form.message
        }else{
          document.getElementById('idMessage').value  = this.oldValue
          this.form.message= this.oldValue 
        }
      }else{
        this.oldValue = this.form.message
      }
    }
  },
  computed:{
    requestAuth() {
      return this.$store.state.auth
    },
    secondTime(){ 
      return Math.floor(this.time)<10 ? '0'+ ((Math.floor(this.time)) - ( Math.floor(this.time/60) > 0 ? 60 * Math.floor(this.time/60) : 0)) : Math.floor(this.time)-( Math.floor(this.time/60) > 0 ? 60 * Math.floor(this.time/60) : 0) < 10 ? '0'+(Math.floor(this.time)-( Math.floor(this.time/60) > 0 ? 60 * Math.floor(this.time/60) : 0)):Math.floor(this.time)-( Math.floor(this.time/60) > 0 ? 60 * Math.floor(this.time/60) : 0) 
    },
    minuteTime(){ 
      return Math.floor(this.time/60)<10 ? '0'+ ((Math.floor(this.time/60)) - ( Math.floor(this.time/3600) > 0 ? 3600 * Math.floor(this.time/3600) : 0)) : Math.floor(this.time/60)-( Math.floor(this.time/3600) > 0 ? 3600 * Math.floor(this.time/3600) : 0) < 10 ? '0'+(Math.floor(this.time/60)-( Math.floor(this.time/3600) > 0 ? 3600 * Math.floor(this.time/3600) : 0)):Math.floor(this.time/60)-( Math.floor(this.time/3600) > 0 ? 3600 * Math.floor(this.time/3600) : 0) 
    },
    requestHttp() {
      return this.$store.state.api
    },
    requestFile() {
      return this.$store.state.apifile
    },
    requestAccueil(){
      return this.$store.state.dataAccueil
    },
  }
}
</script>

<style>
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* For IE, Edge and Firefox */
  .scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  .swiper-slide-participant{
    height: 6rem !important;
    width: 10rem !important;
  }
  .mySwiperParticipant{
    height: auto !important;
    width: 100% !important;
    position: inherit !important;
  }
</style>